import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();
  const shipping = 9.99;
  const total = subtotal + shipping;

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    } else if (newQuantity === 0) {
      removeFromCart(id, size, color);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__empty">
          <h1>CART</h1>
          <p>Your cart is empty</p>
          <Link to="/shop" className="continue-shopping" onClick={toTop}>
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__container">
        <div className="cart-page__left">
          <h1 className="cart-page__title">CART</h1>
          <Link to="/shop" className="cart-page__continue" onClick={toTop}>
            Continue shopping
          </Link>
          
          <div className="cart-page__items">
            {cartItems.map((item, index) => {
              const product = getProductById(item.id);
              if (!product) return null;
              return (
                <div key={index} className="cart-item">
                  <img src={product.image} alt={product.name} className="cart-item__image" />
                  <div className="cart-item__info">
                    <h3 className="cart-item__name">{product.name}</h3>
                    <p className="cart-item__detail">Size: {item.size}</p>
                    <p className="cart-item__detail">Color: {item.color}</p>
                    <div className="cart-item__quantity">
                      <button 
                        className="quantity-btn"
                        onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}
                      >
                        −
                      </button>
                      <span className="quantity-value">{item.quantity}</span>
                      <button 
                        className="quantity-btn"
                        onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}
                      >
                        +
                      </button>
                    </div>
                    <button 
                      className="cart-item__remove"
                      onClick={() => removeFromCart(item.id, item.size, item.color)}
                    >
                      Remove
                    </button>
                  </div>
                  <p className="cart-item__price">${(parseFloat(product.price) * item.quantity).toFixed(2)}</p>
                </div>
              );
            })}
          </div>
        </div>
        
        <div className="cart-page__right">
           
          
          <div className="cart-page__subtotal">
            <span className="subtotal-label">Subtotal</span>
            <span className="subtotal-price">${subtotal.toFixed(2)}</span>
          </div>
          <div className="cart-page__subtotal">
            <span className="subtotal-label">Shipping</span>
            <span className="subtotal-price">${shipping.toFixed(2)}</span>
          </div>
          <div className="cart-page__subtotal">
            <span className="subtotal-label">Total USD</span>
            <span className="subtotal-price">${total.toFixed(2)}</span>
          </div>
          
          <button className="cart-page__checkout" onClick={handleCheckout}>
            CHECK OUT
          </button>
          
          <p className="cart-page__shipping">
            🚚 Standard tracked shipping: $9.99
          </p>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
